import React from 'react'
import { Row, Col, Card, Statistic, Typography, Space } from 'antd'
import { 
  DatabaseOutlined, 
  NodeIndexOutlined, 
  BarChartOutlined,
  LinkOutlined 
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title, Paragraph } = Typography

const HomePage: React.FC = () => {
  const navigate = useNavigate()

  const features = [
    {
      title: '知识图谱展示',
      description: '可视化展示标准文献、机构、人员之间的关系网络',
      icon: <DatabaseOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
      path: '/kg'
    },
    {
      title: '统计分析',
      description: '提供机构和人员维度的多维度统计分析',
      icon: <BarChartOutlined style={{ fontSize: '48px', color: '#52c41a' }} />,
      path: '/stats'
    }
  ]

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <Title level={1} style={{ color: '#1890ff', marginBottom: '16px' }}>
          标准知识图谱数智化系统
        </Title>
        <Paragraph style={{ fontSize: '18px', color: '#666' }}>
          基于Neo4j的知识图谱展示和统计分析平台
        </Paragraph>
      </div>

      <Row gutter={[24, 24]}>
        {features.map((feature, index) => (
          <Col xs={24} sm={12} key={index}>
            <Card
              hoverable
              style={{ 
                height: '200px',
                textAlign: 'center',
                cursor: 'pointer'
              }}
              onClick={() => navigate(feature.path)}
            >
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {feature.icon}
                <Title level={3}>{feature.title}</Title>
                <Paragraph style={{ color: '#666' }}>
                  {feature.description}
                </Paragraph>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: '48px' }}>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="图谱节点"
              value={58152}
              prefix={<NodeIndexOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="关系数量"
              value={132633}
              prefix={<LinkOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="数据源"
              value="Neo4j"
              prefix={<DatabaseOutlined />}
              valueStyle={{ color: '#fa8c16' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default HomePage
